import React from 'react';

import { Image, ResetPasswordForm } from 'src/shared/components';
import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { defaultLocalStorageAdapter } from 'src/shared/graphql';
import { useActivateMutation } from 'src/shared/graphql/generated';
import { baseUrlToRedirectUrl } from 'src/shared/helpers/url';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { TwoColumn } from 'src/shared/layouts';
import { Route } from 'src/shared/route';
import { identify } from 'src/shared/telemetry';

import renderingHero from 'assets/img/rendering/dtc_hero_1.png';

const image = (
  <Image
    alt="a home rendering"
    borderRadius={400}
    shadow="distance300"
    src={renderingHero}
  />
);

const Activate = () => {
  const [activate, { error, loading }] = useActivateMutation();
  const t = useTranslate([TranslationNamespace.SHARED]);

  const onSubmit = async (formData: { password: string }, token: string) => {
    const { data } = await activate({
      variables: { ...formData, token },
    });

    if (data) {
      const {
        user: { id, email, intercomSha },
        jwt: { accessToken, refreshToken },
      } = data.resetPassword;

      try {
        await identify({
          email,
          userId: id,
          intercomSha,
        });
      } finally {
        void defaultLocalStorageAdapter.setAccessToken(accessToken);
        void defaultLocalStorageAdapter.setRefreshToken(refreshToken);

        window.location.href = baseUrlToRedirectUrl(window.location.href);
      }
    }
  };

  return (
    <TwoColumn.Container image={image}>
      <MetaCanonicalLink pathname={Route.RENDERINGS_HUB.path} />
      <MetaTitle title={t('renderings.activate.activateAccount')} />
      <TwoColumn.Header
        heading={t('renderings.activate.view')}
        subheading={t('renderings.activate.setPassword')}
      />
      <TwoColumn.Main>
        <ResetPasswordForm
          error={error}
          loading={loading}
          onSubmit={onSubmit}
          submitText={t('renderings.activate.activate')}
        />
      </TwoColumn.Main>
    </TwoColumn.Container>
  );
};

export { Activate };
